import { useState } from 'react';
import { api } from '../lib/api';
import { useAction, useApi } from '../lib/useApi';
import { ErrorBox, Notice, PageHeader, StatusBadge, fmtDate } from '../components/ui';

export function BillingPage() {
  const plans = useApi<{ configured: boolean; plans: Array<{ key: string; label: string; price: string; maxChildren: number | null }> }>('/billing/plans');
  const subs = useApi<{ subscriptions: Array<{ id: string; plan: string; status: string; current_period_end: string | null }> }>('/billing/subscription');
  const act = useAction();
  const [group, setGroup] = useState({ organisationName: '', seats: 20 });

  const checkout = async (plan: string, extra: Record<string, unknown> = {}) => {
    const r = await act.run(() => api<{ checkoutUrl: string }>('/billing/checkout', { body: { plan, ...extra } }));
    if (r?.checkoutUrl) window.location.href = r.checkoutUrl;
  };
  const desc: Record<string, string> = {
    family_monthly: 'Everything for up to 3 children: games, Voice Tree, Story Vault, Grandparent Calls.',
    family_annual: 'Same as monthly — two months free.',
    tutors_addon: 'Adds weekly Live Circles with vetted tutors. Requires a Family plan.',
    group_licence: 'For Saturday schools, churches, mosques and community groups.',
  };

  return (
    <>
      <PageHeader title="Plans & billing" lead="Payments are handled securely by Stripe. We never see your card number." />
      {plans.data && !plans.data.configured && <p className="alert info">Billing is not configured in this environment (Stripe keys missing).</p>}
      <Notice text={act.notice} />
      <ErrorBox error={act.error} />
      {subs.data && subs.data.subscriptions.length > 0 && (
        <div className="card">
          <h2>Your subscriptions</h2>
          <ul>
            {subs.data.subscriptions.map((s) => (
              <li key={s.id}>
                {s.plan.replace(/_/g, ' ')} · <StatusBadge status={s.status} /> {s.current_period_end && `· renews ${fmtDate(s.current_period_end, false)}`}
              </li>
            ))}
          </ul>
        </div>
      )}
      <div className="grid grid-2" style={{ marginTop: 16 }}>
        {plans.data?.plans.map((p) => (
          <div key={p.key} className={`card stack${p.key === 'family_annual' ? ' featured' : ''}`}>
            {p.key === 'family_annual' && <span className="ribbon">Best value · two months free</span>}
            <h2>{p.label}</h2>
            <p className="stat">{p.price}</p>
            <p>{desc[p.key]}</p>
            {p.key === 'group_licence' ? (
              <form
                className="row"
                onSubmit={(e) => {
                  e.preventDefault();
                  void checkout('group_licence', group);
                }}
              >
                <input aria-label="Organisation" placeholder="Organisation name" value={group.organisationName} onChange={(e) => setGroup({ ...group, organisationName: e.target.value })} required />
                <input aria-label="Seats" type="number" min={10} value={group.seats} onChange={(e) => setGroup({ ...group, seats: Number(e.target.value) })} style={{ width: 90 }} />
                <button className="btn small">Buy licence</button>
              </form>
            ) : (
              <button className="btn" onClick={() => checkout(p.key)} disabled={act.busy}>
                Choose {p.label}
              </button>
            )}
          </div>
        ))}
      </div>
      <p className="small muted" style={{ marginTop: 16 }}>Legacy Books are one-off purchases ($60–$150) from the Legacy Book page.</p>
    </>
  );
}
